import routerOptions0 from "/app/node_modules/.pnpm/nuxt@4.5.2_7347c67305e3e003364566b008310163/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}